import axios from "axios";
import {
  IListResponseModel,
  IPageResponseModel,
  ISearchResponseModel,
} from "./models";

const api = axios.create({
  // prod : "https://yatirimhaber.fibabanka.com.tr/api/"
  // preprod: "https://yatirimhaber.agencylook.net/api/"
  baseURL: "https://yatirimhaber.fibabanka.com.tr/api/",
  timeout: 5000,
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

export const getPageData = async (
  slug: string
): Promise<IPageResponseModel> => {
  try {
    const response = await api.get(`/page/page?url=${slug}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch page data");
  }
};

export const getSearchResponse = async (
  term: string,
  type: string
): Promise<ISearchResponseModel> => {
  try {
    const response = await api.get(`/search/list?keyword=${term}&type=${type}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch page data");
  }
};

export const getCardListResponse = async (
  type: string,
  pageId: string,
  page: number = 1,
  year: string = "0",
  month: string = "0",
  categoryType: string = ""
): Promise<IListResponseModel> => {
  try {
    const response = await api.post(`pageservices/content-list`, {
      type: type,
      parentPageID: pageId,
      page: page,
      pageSize: 8,
      year: year,
      month: month,
      categoryType,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch page data");
  }
};
